import ModalRoutesView from './modal_routes_view';

export default ModalRoutesView;
